import { createAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '@ezugi/types';

type GenericObjectPayload = GenericPayloadType;
type TotalBetPayload = {
  value: number;
}

export const betActions = {
  bet: {
    request: createAction<GenericObjectPayload>('bet/request'),
    success: createAction('bet/success'),
    failure: createAction('bet/failure'),
    add: createAction<GenericObjectPayload>('bet/add'),
    set: createAction<GenericObjectPayload>('bet/set'),
    reset: createAction('bet/reset'),
    clear: createAction('bet/clear'),
    cache: createAction<GenericObjectPayload | void>('bet/cache'),
    rebet: createAction('bet/rebet'),
    update: createAction<GenericObjectPayload>('bet/update'),
    double: createAction('bet/double'),
    callBet: createAction('bet/callBet'),
    fold: createAction('bet/fold'),
    remove: createAction<string | string[]>('bet/remove'),
  },
  totalBet: {
    set: createAction<TotalBetPayload>('totalBet/set'),
  },
  history: {
    pop: createAction('history/pop'),
    reset: createAction('history/reset'),
    update: createAction<GenericObjectPayload>('history/update'),
  },
};
